import React, { useMemo } from 'react'
import { CheckboxSelector, CheckboxSelectorInner } from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../i18n/useTranslation'
import useCountries from '../../../Model/Countries/List'
import FilterBadge from '../../../common/FilterBadge'

const CountriesFilter = (props) => {
  const { translate } = useTranslation()
  const { countryFilters, setCountryFilters, className, style = {}, useInner = false } = props
  const { data: countries, loading: countriesLoading } = useCountries({ limit: 0 })
  const baseCountries = useMemo(
    () => (!countriesLoading && countries && countries.docs ? countries.docs.map((country) => country.id) : []),
    [countries, countriesLoading]
  )
  const countriesArray = useMemo(() => countries && countries.docs ? countries.docs : baseCountries, [countries, baseCountries])
  
  const selectorProps = {
    className,
    setDataFilters: setCountryFilters,
    direction: 'bottomRight',
    dataFilters: countryFilters,
    data: countriesArray.map(item => ({ name: item.name, id: item.id })).sort((a, b) => a.name.localeCompare(b.name)),
    typeFilter: 'countries',
    strings: {
      viewAll: translate('filters.plans.viewAll'),
      buttonCancel: translate('filters.plans.buttonCancel'),
      buttonApply: translate('filters.plans.buttonApply'),
      search: translate('filters.plans.search')
    },
    style
  }

  return useInner ? (
    <CheckboxSelectorInner
      {...selectorProps}
    />
  ) : (
    <CheckboxSelector {...selectorProps}>
      <FilterBadge
        title={translate('filters.plans.countriesTitle')}
        options={selectorProps.data}
        selectedIds={countryFilters}
        onClearFilters={() => setCountryFilters([])}
      />
    </CheckboxSelector>
  )
}
export default CountriesFilter
